import { useGetCreativeAdDetailQuery } from '../../../api/ua-insights'
import { useUAInsightsScope } from './useUAInsightsNavigation'

/** Creative detail; network and month scope its `gameMaxInstallShare` anchor. */
export const useCreativeAdDetails = (creativeId: string | null) => {
  const { networkId, month } = useUAInsightsScope()
  const { data, isFetching, isError, refetch } = useGetCreativeAdDetailQuery(
    { creativeId: creativeId ?? '', networkId: networkId ?? undefined, month: month ?? undefined },
    { skip: !creativeId }
  )
  return { data, isLoading: isFetching, isError, refetch }
}
